// src/pushSetup.js
import { db } from "./firebase";
import { doc, setDoc, updateDoc } from "firebase/firestore";

export async function initPushNotifications(userId) {
  if (!userId) {
    console.warn('[Push] initPushNotifications chiamato senza userId');
    return;
  }

  console.log('[Push] Inizializzo le notifiche per user:', userId);

  try {
    // Dynamic import only for native builds (prevents errors on web)
    const { PushNotifications } = await import('@capacitor/push-notifications');

    // 1️⃣ Controllo permessi
    const permStatus = await PushNotifications.checkPermissions();
    console.log('[Push] Permessi attuali:', permStatus);

    if (permStatus.receive !== 'granted') {
      const req = await PushNotifications.requestPermissions();
      console.log('[Push] Richiesta permessi:', req);
      if (req.receive !== 'granted') {
        console.warn('[Push] Permessi notifiche NON concessi, esco');
        return;
      }
    }

    // 2️⃣ Listener registrazione device
    PushNotifications.addListener('registration', async (token) => {
      try {
        console.log('✅ [Push] Device registered con token:', token.value);

        const userRef = doc(db, 'users', userId);
        // Salvo il token FCM nel documento utente
        await updateDoc(userRef, {
          fcmToken: token.value,
        }).catch(async (err) => {
          // Se updateDoc fallisce per doc mancante, uso setDoc merge
          console.warn('[Push] updateDoc fallito, provo setDoc merge:', err);
          await setDoc(userRef, { fcmToken: token.value }, { merge: true });
        });

        console.log('[Push] 💾 Token push salvato in Firestore per user:', userId);
      } catch (err) {
        console.error('[Push] Errore salvando il token in Firestore:', err);
      }
    });

    // 3️⃣ Listener errori registrazione
    PushNotifications.addListener('registrationError', (error) => {
      console.error('❌ [Push] Errore registrazione push:', error);
    });

    // 4️⃣ NOTA: Il listener pushNotificationReceived è stato spostato in App.jsx
    // come listener globale. Qui gestiamo solo la registrazione del token FCM.

    // 5️⃣ Listener click su notifica
    PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
      console.log('🔔 [Push] Azione su notifica:', JSON.stringify(action));
      
      // Naviga in base al tipo di notifica
      const data = action.notification.data;
      console.log('[Push] 📊 Dati notifica:', data);
      
      if (data) {
        // Gestione navigazione per like su wishlist
        if (data.type === 'like' && data.wishlistId) {
          console.log('[Push] 🎯 Navigazione a wishlist:', data.wishlistId);
          window.location.href = `/wishlist/${data.wishlistId}`;
        }
        // Gestione navigazione per follow
        else if (data.type === 'follow' && data.senderId) {
          console.log('[Push] 🎯 Navigazione a utente:', data.senderId);
          window.location.href = `/utente/${data.senderId}`;
        }
        // Gestione navigazione per collaboration
        else if (data.type === 'collaboration' && data.wishlistId) {
          console.log('[Push] 🎯 Navigazione a wishlist collaborazione:', data.wishlistId);
          window.location.href = `/wishlist/${data.wishlistId}`;
        }
        // Default: vai alla home se mancano i dati
        else {
          console.log('[Push] 🏠 Navigazione default alla home (dati mancanti)');
          window.location.href = '/home';
        }
      }
    });

    // 6️⃣ Registro il device (chiede il token FCM via native)
    await PushNotifications.register();
    console.log('[Push] ✅ initPushNotifications completato per user:', userId);
  } catch (err) {
    console.error('[Push] ❌ Errore generale in initPushNotifications:', err);
  }
}
